import { render, staticRenderFns } from "./CurrencySelection.vue?vue&type=template&id=0f0d8fe4&scoped=true"
import script from "./CurrencySelection.vue?vue&type=script&lang=js"
export * from "./CurrencySelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d8fe4",
  null
  
)

export default component.exports